<template>
  <div>
    <span class="currency">{{ params.value | currencyFilter('$', 2) }}</span>
  </div>
</template>

<script>
export default {};
</script>